export const json = {
  locale: 'it_it',
  recipe: "Ricetta",
  machine: "Macchina",
  task: {
    state: {
      unset: "Non impostato",
      todo: "Da fare",
      in_progress: "In corso",
      to_test: "Da testare",
      wont_fix: "Non verrà risolto",
      done: "Completato",
      paused: "In pausa",
    },
    priority: {
      unset: "Nessuna priorità",
      low: "Bassa",
      normal: "Normale",
      high: "Alta",
      max: "Urgente",
    },
    table: {
      header: {
        title: "Attività",
        state: "Stato",
        priority: "Priorità",
        labels: "Etichette",
      },
      placeholder: {
        filter: {
          priority: "Filtra email...",
        },
      },
      "no-results": "Nessun risultato",
    },
    add: {
      title: "Aggiungi nuova attività",
      name: "Nome attività",
      name_placeholder: "Inserisci il nome dell'attività",
      priority: "Priorità",
      title_translations: "Traduzioni del titolo",
      description_translations: "Traduzioni della descrizione",
      icon_url: "URL icona (opzionale)",
      icon_url_placeholder: "Inserisci l'URL dell'icona",
      labels: "Etichette",
      assigned_to: "Assegnato a",
      assigned_to_placeholder: "Seleziona moderatore",
      submit: "Crea attività",
      cancel: "Annulla",
      edit_translations: "Modifica traduzioni",
      save_translations: "Salva traduzioni",
      required_field: "Questo campo è obbligatorio",
      en_us_required: "La traduzione in inglese (US) è obbligatoria",
      success: "Attività creata con successo!",
      error: "Errore durante la creazione dell'attività. Riprova.",
    },
  },
  table: {
    select: {
      of: "di",
      rows: "righe selezionate.",
    },
  },
  cookies: {
    link: 'Politica dei Cookie',
    title: "Consenso ai cookie",
    description:
      "Questo sito web utilizza i cookie per garantire il corretto funzionamento e migliorare la tua esperienza. Seleziona quali cookie ci permetti di utilizzare.",
    policy_link: "Maggiori informazioni nella nostra Politica dei Cookie",
    accept_all: "Accetta tutti",
    accept_selected: "Accetta selezionati",
    accept_essential: "Solo essenziali",
    manage: "Gestisci preferenze",
    save: "Salva preferenze",
    back: "Indietro",
    categories: {
      essential: {
        title: "Cookie essenziali",
        description: "Questi cookie sono necessari per il funzionamento del sito web e non possono essere disattivati.",
      },
      functional: {
        title: "Cookie funzionali",
        description: "Questi cookie consentono funzionalità e caratteristiche personalizzate.",
      },
      analytics: {
        title: "Cookie analitici",
        description: "Questi cookie ci aiutano a capire come i visitatori interagiscono con il sito web.",
      },
      marketing: {
        title: "Cookie di marketing",
        description: "Questi cookie vengono utilizzati per tracciare i visitatori attraverso i siti web a fini pubblicitari.",
      },
    },
    expiration: {
      title: "Scadenza dei cookie",
      description: "Scegli per quanto tempo verranno ricordate le tue preferenze sui cookie:",
      thirty_days: "30 giorni",
      ninety_days: "90 giorni",
      six_months: "6 mesi",
      one_year: "1 anno",
    },
    policy: {
      title: "Politica dei cookie",
      introduction:
        "Questa Politica dei Cookie spiega come utilizziamo i cookie e tecnologie simili per riconoscerti quando visiti il nostro sito web. Spiega cosa sono queste tecnologie e perché le utilizziamo, nonché i tuoi diritti per controllare il nostro utilizzo di esse.",
      what_are_cookies: "Cosa sono i cookie?",
      what_are_cookies_text:
        "I cookie sono piccoli file di dati che vengono posizionati sul tuo computer o dispositivo mobile quando visiti un sito web. I cookie sono ampiamente utilizzati dai proprietari di siti web per far funzionare i loro siti, o per farli funzionare in modo più efficiente, nonché per fornire informazioni di reportistica.",
      how_we_use: "Come utilizziamo i cookie",
      how_we_use_text:
        "Utilizziamo i cookie per diversi motivi. Alcuni cookie sono necessari per motivi tecnici affinché il nostro sito web funzioni, e li chiamiamo cookie 'essenziali' o 'necessari'. Altri cookie ci permettono di tracciare e indirizzare gli interessi dei nostri utenti per migliorare l'esperienza sul nostro sito web. Terze parti servono cookie attraverso il nostro sito web per pubblicità, analisi e altri scopi.",
      types: "Tipi di cookie che utilizziamo",
      managing: "Gestione dei tuoi cookie",
      managing_text:
        "Puoi impostare o modificare i controlli del tuo browser web per accettare o rifiutare i cookie. Se scegli di rifiutare i cookie, puoi comunque utilizzare il nostro sito web, anche se il tuo accesso ad alcune funzionalità e aree del nostro sito web potrebbe essere limitato. Poiché i mezzi con cui puoi rifiutare i cookie attraverso i controlli del tuo browser web variano da browser a browser, dovresti visitare il menu di aiuto del tuo browser per ulteriori informazioni.",
      third_party: "Cookie di terze parti",
      third_party_text:
        "Oltre ai nostri cookie, potremmo anche utilizzare vari cookie di terze parti per segnalare statistiche di utilizzo del sito web, fornire annunci pubblicitari sul e attraverso il sito web, e così via.",
      updates: "Aggiornamenti a questa Politica dei Cookie",
      updates_text:
        "Potremmo aggiornare questa Politica dei Cookie di tanto in tanto per riflettere, ad esempio, cambiamenti nei cookie che utilizziamo o per altre ragioni operative, legali o normative. Pertanto, visita nuovamente regolarmente questa Politica dei Cookie per rimanere informato sul nostro utilizzo di cookie e tecnologie correlate.",
      purpose: "Scopo",
      essential_purpose:
        "Necessari per il corretto funzionamento del sito web. Questi cookie consentono funzioni di base come la navigazione delle pagine e l'accesso ad aree sicure del sito web.",
      functional_purpose:
        "Consentono al sito web di ricordare le scelte che fai (come il tuo nome utente, la lingua o la regione in cui ti trovi) e forniscono funzionalità migliorate e più personali.",
      analytics_purpose:
        "Ci aiutano a capire come i visitatori interagiscono con il nostro sito web raccogliendo e riportando informazioni in modo anonimo.",
      marketing_purpose:
        "Utilizzati per tracciare i visitatori attraverso i siti web. L'intento è quello di mostrare annunci che siano rilevanti e coinvolgenti per il singolo utente.",
      always_active: "Sempre attivo",
      active: "Attivo",
      inactive: "Inattivo",
      back_to_site: "Torna al sito",
    },
  },
  sidebar: {
    platform: "Piattaforma",
    dashboard: "Dashboard",
    tasks: {
      title: "Attività",
      add: "Aggiungi attività"
    },
    analytics: "Analisi",
    users: "Utenti",
    settings: "Impostazioni",
    admin_panel: {
      title: "Pannello di amministrazione",
      mods: {
        title: "Moderatori",
        add: "Aggiungi moderatore"
      },
      labels: {
        title: "Etichette",
        add: "Aggiungi etichetta"
      },
      pending: "Approvazioni in sospeso"
    },
    documentation: {
      title: "Documentazioni",
      create: "Crea documentazione"
    },
    search: "Cerca nei documenti..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "Panoramica",
          userInfo: "Informazioni utente",
          userId: "ID utente",
          role: "Ruolo",
          memberSince: "Membro dal"
        },
        tasks: {
          title: "Attività",
          assigned: "Attività assegnate",
          noTasks: "Nessuna attività assegnata ancora."
        },
        activity: {
          title: "Attività",
          recent: "Attività recente",
          noActivity: "Nessuna attività recente."
        },
        settings: {
          title: "Impostazioni",
          user: "Impostazioni utente",
          admin: "Impostazioni amministratore per questo utente."
        }
      }
    },
    mods: {
      error: {
        unknownError: "Errore sconosciuto"
      },
      access: {
        title: "Accesso negato",
        description: "Non hai il permesso di accedere a questa pagina."
      },
      add: {
        link: "Aggiungi nuovo mod",
        title: "Aggiungi nuovo mod",
        addDesc: "Crea una nuova voce mod",
        name: {
          title: "Nome",
          placeholder: "Inserisci il nome del mod"
        },
        description: {
          title: "Descrizione",
          placholder: "Inserisci la descrizione in "
        },
        optional: "Opzionale",
        versions: {
          title: "Versioni",
          add: "Aggiungi versione"
        },
        icon: "URL icona",
        launchers: "Launcher",
        form: {
          errors: {
            alert: {
              title: "Errore",
              description: "Correggi gli errori sopra prima di inviare."
            },
            name: "Il nome è obbligatorio",
            description: "La descrizione in inglese (US) è obbligatoria",
            curseforge: "Il link CurseForge è obbligatorio",
            invalidURL: "Formato URL non valido",
            versions: "È richiesta almeno una versione",
            launchers: "È richiesto almeno un launcher"
          }
        },
        cancel: "Annulla",
        create: {
          loading: "Creazione in corso...",
          default: "Crea mod"
        },
        langDataError: "Errore nel caricamento dei dati della lingua:",
      },
      noMods: "Nessun mod trovato",
      getStarted: "Inizia creando un nuovo mod.",
      fetch: {
        error: 'Errore nel recupero della documentazione:'
      },
      "delete": {
        link: "Elimina",
        confirm: "Sei sicuro di voler eliminare questo mod?"
      },
      toast: {
        delete: {
          success: {
            title: "Mod eliminato",
            description: "Il mod è stato eliminato con successo."
          },
          error: {
            console: "Errore nell'eliminazione del mod:",
            fallback: "Eliminazione del mod fallita",
            title: "Errore",
            description: "Si è verificato un errore durante l'eliminazione del mod."
          }
        },
        edit: {
          success: {
            title: "Successo",
            description: "Mod aggiornato con successo"
          }
        },
        add: {
          fallback: "Creazione del mod fallita",
          success: {
            title: "Successo",
            description: "Mod creato con successo"
          },
          console: "Errore nella creazione del mod:",
          error: {
            title: "Errore",
            description: "Creazione del mod fallita"
          }
        }
      },
      noDesc: "Nessuna descrizione disponibile",
      docs: {
        link: "Documentazione"
      },
      edit: {
        link: "Modifica",
        title: "Modifica mod",
        langDataError: "Errore nel caricamento dei dati della lingua:",
        notFound: "Mod non trovato",
        failFetch: "Recupero del mod fallito",
        unknownError: "Si è verificato un errore sconosciuto",
        form: {
          errors: {
            name: "Il nome è obbligatorio",
            description: "La descrizione in inglese (US) è obbligatoria",
            curseforge: "Il link CurseForge è obbligatorio",
            versions: "Tutti i campi versione devono essere compilati",
            launchers: "Deve essere selezionato almeno un launcher"
          }
        },
        modInfo: "Informazioni mod",
        editModInfo: "Modifica le informazioni del mod.",
        name: "Nome",
        description: {
          title: "Descrizione",
          required: "La descrizione in inglese (US) è obbligatoria."
        },
        optional: "Opzionale",
        versions: {
          title: "Versioni",
          add: "Aggiungi versione",
          remove: "Rimuovi"
        },
        icon: "URL icona",
        launchers: "Launcher",
        cancel: "Annulla",
        update: "Aggiorna mod"
      }
    },
    docs: {
      access: {
        title: "Accesso negato",
        description: "Non hai il permesso di accedere a questa pagina."
      },
      title: "Documentazione",
      description: "Sfoglia e leggi la documentazione per i mod di Minecraft",
      create: {
        link: "Crea documentazione",
        tab: "Crea nuova",
        content: {
          title: "Nessun mod disponibile",
          description: "Tutti i mod hanno già una documentazione o non hai il permesso di creare documentazione per nessun mod."
        },
        title: "Crea documentazione"
      },
      published: "Pubblicato",
      pending: "In attesa",
      noDocs: {
        title: "Nessuna documentazione disponibile",
        description: "Non ci sono ancora pagine di documentazione pubblicate."
      },
      noPending: {
        title: "Nessuna documentazione in attesa",
        superAdmin: "Non ci sono pagine di documentazione in attesa di approvazione",
        rest: "Non hai pagine di documentazione in attesa."
      },
      user: {
        noDocs: {
          title: "Nessuna documentazione disponibile",
          description: "Non ci sono ancora pagine di documentazione pubblicate."
        }
      },
      card: {
        pending: "In attesa di approvazione",
        view: "Visualizza",
        edit: "Modifica"
      },
      add: {
        title: "Crea nuova documentazione",
        description: "Crea documentazione completa per un mod di Minecraft",
        noMods: {
          title: "Nessun mod disponibile",
          description: "Non ci sono mod disponibili per la creazione di documentazione. O tutti i mod hanno già una documentazione o non hai il permesso di creare documentazione per nessun mod."
        },
        card: {
          title: "Informazioni di base",
          description: "Fornisci informazioni di base sulla documentazione.",
          descriptionLink: "Visualizza la nostra guida alla documentazione",
          content: {
            modSelect: "Seleziona un mod",
            modSelectDesc: "Seleziona il mod per cui vuoi creare documentazione",
            noDesc: "Nessuna descrizione disponibile",
            form: {
              title: {
                title: "Titolo",
                placeholder: "Inserisci il titolo della documentazione",
                description: "Il titolo della tua documentazione (è richiesto l'inglese US)"
              },
              description: {
                title: "Descrizione",
                placeholder: "Inserisci la descrizione della documentazione",
                description: "Una breve descrizione della tua documentazione (è richiesto l'inglese US)"
              },
              coverImage: {
                title: "URL immagine di copertina (Opzionale)",
                description: "Fornisci un URL per l'immagine di copertina della tua documentazione"
              },
              tabs: {
                preview: {
                  title: "Anteprima",
                  content: {
                    title: "Anteprima",
                    description: "Anteprima di come apparirà la tua documentazione",
                    form: {
                      title: "Titolo della documentazione",
                      description: "La descrizione della documentazione apparirà qui."
                    },
                    section: "sezione",
                    article: "articolo",
                    modSelect: {
                      title: "Seleziona un mod",
                      description: "Seleziona un mod per visualizzare l'anteprima della tua documentazione"
                    }
                  }
                },
                information: {
                  title: "Informazioni",
                  content: {
                    title: "Informazioni",
                    description: "Informazioni importanti sulla creazione di documentazione",
                    approval: {
                      title: "Approvazione richiesta",
                      description: "La documentazione creata da editor e amministratori richiede l'approvazione di un super amministratore prima di diventare pubblica. Apri un ticket per richiederlo."
                    },
                    after: {
                      title: "Dopo la creazione:",
                      list: {
                        one: "Sarai reindirizzato all'editor di documentazione",
                        two: "Una sezione e un articolo predefiniti verranno creati automaticamente",
                        three: "Puoi aggiungere altre sezioni e articoli secondo necessità",
                        four: "Puoi caricare immagini e aggiungere componenti personalizzati",
                        five: "Puoi visualizzare l'anteprima della tua documentazione prima di inviarla per l'approvazione. (Deve essere salvata prima dell'anteprima)"
                      }
                    },
                    create: {
                      loading: "Creazione in corso...",
                      default: "Crea documentazione"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "Recupero dei mod fallito",
          documentation: "Recupero della documentazione fallito"
        },
        success: {
          title: "Documentazione creata",
          description: "La tua documentazione è stata creata con successo."
        },
        error: {
          fetching: {
            mods: {
              console: "Errore nel recupero dei mod:",
              toast: {
                title: "Errore",
                description: "Caricamento dei mod fallito. Riprova."
              }
            }
          },
          creating: {
            failed: "Creazione della documentazione fallita",
            error: {
              console: "Errore nella creazione della documentazione:",
              toast: {
                title: "Errore",
                description: "Creazione della documentazione fallita. Riprova."
              }
            }
          }
        }
      }
    }
  }
}